import styled from "styled-components";
import { color } from "../../styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export const BoxWrapper = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: 10px;
  border: 1px solid ${color.secondary.GREY_4};
  background-color: ${color.emphasis.NEUTRAL_N5};
  height: 34px;
  align-items: center;
  border-radius: 8px;

  &:hover {
    cursor: pointer;
    border-color: ${color.secondary.GREY_4};
  }
`;

export const StyledMenu = styled(Menu)`
  & .MuiPaper-root {
    width: 100%;
    padding: 8px 8px 10px 16px;
    display: flex;
    flex-direction: column;
    border: 1px solid ${color.secondary.GREY_4};
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
    border-radius: 5px;
    box-sizing: border-box;
    width: 100%;
    justify-content: flex-start;
    margin-top: 6px;
  }
`;

export const CustomMenuItem = styled(MenuItem)`
  && {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    cursor: pointer;

    &:hover {
      color: ${color.primary.BLUE_B100};
    }
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 16px;
    padding: 0px;
    display: flex;
    height: 24px;
    gap: 8px;

    &:last-child {
      margin-bottom: 0;
    }
    
    &:focus {
      background: none;

      &:hover {
        background: rgba(0, 0, 0, 0.04);
      }
    }
  }
`;
